import ErrorBase from "./ErrorBase";

export class UnauthorizedError extends ErrorBase {
  constructor() {
    super({
      name: "UnauthorizedError",
      title: "error_unauthorized_title",
      message: "error_unauthorized_message",
      icon: "/images/unauthorised.svg",
    });
    Object.setPrototypeOf(this, UnauthorizedError.prototype);
  }
}
